import type { AuthService } from 'types/AuthService';
import type { SessionUseCases } from '@subscriptions/composition/types';
import { createAuthSessionAdapter } from '@subscriptions/infrastructure/session/AuthSessionAdapter';
import { getCurrentOrganizationUuidUseCase, getCurrentUserUuidUseCase } from '@subscriptions/application/use-cases';

/**
 * Assembles the use cases that read the signed-in session.
 *
 * @param authService - Authentication service handed over at bootstrap
 */
export const createSessionUseCases = (authService: AuthService): SessionUseCases => {
  const sessionPort = createAuthSessionAdapter(authService);

  return Object.freeze({
    getCurrentOrganizationUuid: getCurrentOrganizationUuidUseCase(sessionPort),
    getCurrentUserUuid: getCurrentUserUuidUseCase(sessionPort),
  });
};
